import { M as MathUtils } from './mathUtils-f6581b44.js';

const debounce = (func, waitFor = 200) => {
    let timeout = null;
    const debounced = (...args) => {
        if (timeout !== null) {
            clearTimeout(timeout);
            timeout = null;
        }
        timeout = setTimeout(() => func(...args), waitFor);
    };
    return debounced;
};

var ScrollBoundaryDirection;
(function (ScrollBoundaryDirection) {
    ScrollBoundaryDirection["Up"] = "up";
    ScrollBoundaryDirection["Down"] = "down";
})(ScrollBoundaryDirection || (ScrollBoundaryDirection = {}));
const SCROLL_DEFAULT_BOUNDARY_THRESHOLD = {
    bottom: 90,
    top: 10,
};
class ScrollBoundaryTools {
    static getBoundaryDetector(boundaryActions, boundaryThreshold) {
        const threshold = boundaryThreshold !== null && boundaryThreshold !== void 0 ? boundaryThreshold : SCROLL_DEFAULT_BOUNDARY_THRESHOLD;
        const onReachTopThreshold = debounce((event) => { var _a; return (_a = boundaryActions.onReachTopThreshold) === null || _a === void 0 ? void 0 : _a.call(boundaryActions, event); }, 100);
        const onReachBottomThreshold = debounce((event) => { var _a; return (_a = boundaryActions.onReachBottomThreshold) === null || _a === void 0 ? void 0 : _a.call(boundaryActions, event); }, 100);
        let prev = 0;
        return async (event) => {
            if (!event.currentTarget)
                return;
            const direction = event.currentTarget.scrollTop - prev < 0
                ? ScrollBoundaryDirection.Up
                : ScrollBoundaryDirection.Down;
            const position = MathUtils.precision.toPrecision(MathUtils.proportion.percentage({
                value: event.currentTarget.scrollTop,
                from: event.currentTarget.scrollHeight - event.currentTarget.offsetHeight,
            }), { numberOfDecimalPlaces: 0 });
            prev = event.currentTarget.scrollTop;
            if (threshold.top &&
                position <= threshold.top &&
                direction === ScrollBoundaryDirection.Up) {
                await onReachTopThreshold(event);
            }
            if (threshold.bottom &&
                position >= threshold.bottom &&
                direction === ScrollBoundaryDirection.Down) {
                await onReachBottomThreshold(event);
            }
        };
    }
    static getScrollToPercentagePosition() {
        return (event, percentage, options) => {
            var _a, _b, _c, _d;
            if (!event.target)
                return;
            event.target.scrollTo(Object.assign({ top: (((_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.scrollHeight) !== null && _b !== void 0 ? _b : 0) -
                    ((_d = (_c = event.target) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 0)) *
                    (percentage / 100) }, options));
        };
    }
    static getScrollToPosition() {
        return (event, position, options) => {
            if (!event.target)
                return;
            event.target.scrollTo(Object.assign({ top: position }, options));
        };
    }
}

export { ScrollBoundaryTools as S, SCROLL_DEFAULT_BOUNDARY_THRESHOLD as a, debounce as d };
//# sourceMappingURL=scrollBoundaryTools-4fc80d69.js.map
